import { useInfiniteQuery } from 'react-query';
import { videoKeys } from './videosKeys';
import { getVideos } from './useGetVideos';
import { VideoListParams } from '../types';
import { useToastError } from 'lib/hooks';

export const useInfiniteQueryVideos = (params: VideoListParams) => {
  const { showError } = useToastError();
  return useInfiniteQuery(
    videoKeys.infinite_videos(params),
    ({ pageParam = 0 }) =>
      getVideos({
        ...params,
        page: pageParam,
      }),

    {
      refetchOnMount: true,
      getNextPageParam: (_, allPages) => {
        return allPages.length;
      },
      onError: err => {
        showError(err);
      },
    }
  );
};
